import { render, staticRenderFns } from "./NgTextarea.vue?vue&type=template&id=1fefeb68&scoped=true&"
import script from "./NgTextarea.vue?vue&type=script&lang=js&"
export * from "./NgTextarea.vue?vue&type=script&lang=js&"
import style0 from "./NgTextarea.vue?vue&type=style&index=0&id=1fefeb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fefeb68",
  null
  
)

export default component.exports